import React, { useMemo } from 'react';
import ToggleButton from '../../atoms/togglebutton/ToggleButton';

interface IButtonOptionProps {
  title: string;
  id: number;
  customStyle?: React.CSSProperties;
  radioBehaviour?: boolean;
  labelStyle?: React.CSSProperties;
  isSelected: boolean;
  onChangeHandler: (event: React.MouseEventHandler<HTMLDivElement>, isChecked: boolean) => void;
  value?: string | number;
  animate?: boolean;
  additionalStyle?: React.CSSProperties;
  elementRef?: any;
  index: number;
  name?: string;
  isCompletionProfileForm?: boolean;
}

const JoinOptionButton: React.FC<IButtonOptionProps> = (props: IButtonOptionProps) => {
  const {
    title,
    id,
    onChangeHandler,
    labelStyle = {},
    isSelected = false,
    value,
    animate = true,
    elementRef,
    index,
    additionalStyle = {},
    name,
    isCompletionProfileForm,
  } = props;

  const toggleBtnLabelStyle1 = useMemo(() => {
    return {
      padding: '2px 6px 0px',
      lineHeight: '24px',
      fontSize: 13,
      fontWeight: 600,
      color: isSelected ? '#FFFFFF' : '#2B8FD7',
      ...labelStyle,
    };
  }, [isSelected, labelStyle]);

  const toggleBtnCustomStyle = useMemo(() => {
    const opacity = animate ? (value === null ? 1 : isSelected ? 1 : 0) : 1;
    const zIndex = isSelected ? 1 : 0;

    return {
      cursor: 'pointer',
      paddingTop: 3,
      paddingBottom: 3,
      order: index + 1,
      height: 28,
      textAlign: 'center',
      borderRadius: 4,
      border: '1px solid #2B8FD7',
      margin: '0 15px 0 0',
      zIndex,
      opacity,
      overflow: 'hidden',
      display: 'inline-block',
      transition: 'background-color 0.3s, opacity 0.3s',
      ...additionalStyle,
    };
  }, [isSelected, additionalStyle, value, animate, index, isCompletionProfileForm]);

  return (
    <ToggleButton
      elementRef={elementRef}
      labelStyle={toggleBtnLabelStyle1}
      customStyle={{
        ...toggleBtnCustomStyle,
        ...(isCompletionProfileForm && {
          display: animate && (value === null || isSelected) ? 'inline-block' : 'none',
        }),
        backgroundColor: isSelected ? '#2B8FD7' : 'transparent',
      }}
      dataTestId={`${name}${id}`}
      key={id}
      title={title}
      id={id}
      onChangeHandler={onChangeHandler}
      hideIcons={true}
    />
  );
};

export default JoinOptionButton;
